/* eslint-disable indent */
let sliderInit = (n) => {
  document.querySelectorAll('.js-media-list').forEach((mediaList, i) => {
    let swiper;
    if (mediaList.classList.contains('js-media-list-mobile')) {
      new ResizeObserver(() => {
        if (document.body.clientWidth > 575) {
          swiper && swiper.destroy();
          mediaList.querySelector('.swiper-wrapper').removeAttribute('style');
          mediaList.classList.remove('swiper');
        } else if (!mediaList.classList.contains('swiper-initialized')) {
          swiper = new Swiper(mediaList, {
            slidesPerView: 1,
            spaceBetween: 1,
            mousewheel: { forceToAxis: true },
            autoHeight: false,
            speed: 500,
            navigation: {
              nextEl: '.product .product__slider-nav .swiper-button-next',
              prevEl: '.product .product__slider-nav .swiper-button-prev',
            },
            pagination: {
              el: '.product .product__pagination',
              type: 'custom',
              renderCustom: (e, t, i) => {
                let s = '';
                for (let e = 1; e < i + 1; e++) {
                  s +=
                    e == t
                      ? `<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`
                      : `<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
                }
                return s;
              },
            },
            on: {
              slideChange() {
                window.pauseAllMedia();
                this.params.noSwiping = false;
                if (document.querySelector('.js-popup-slider')?.swiper) {
                  document.querySelector('.js-popup-slider').swiper.slideTo(this.activeIndex);
                }
              },
              slideChangeTransitionEnd() {
                this.slides[this.activeIndex]
                  .querySelector('model-viewer')
                  ?.querySelector('.shopify-model-viewer-ui__button--poster')
                  .removeAttribute('hidden');
              },
              touchStart() {
                const mv = this.slides[this.activeIndex].querySelector('model-viewer');
                if (mv) {
                  if (mv.classList.contains('shopify-model-viewer-ui__disabled')) {
                    this.params.noSwiping = false;
                  } else {
                    this.params.noSwiping = true;
                    this.params.noSwipingClass = 'swiper-slide';
                  }
                }
              },
            },
          });
        }
      }).observe(mediaList.closest('.product__outer'));
    } else if (mediaList.classList.contains('stacked-media-list-mobile')) {
      new ResizeObserver(() => {
        if (document.body.clientWidth <= 575) {
          swiper && swiper.destroy();
          mediaList.querySelector('.swiper-wrapper').removeAttribute('style');
          mediaList.classList.remove('swiper');
        } else if (!mediaList.classList.contains('swiper-initialized')) {
          swiper = new Swiper(mediaList, {
            slidesPerView: 1,
            spaceBetween: 1,
            mousewheel: { forceToAxis: true },
            autoHeight: false,
            speed: 500,
            navigation: {
              nextEl: '.product .product__slider-nav .swiper-button-next',
              prevEl: '.product .product__slider-nav .swiper-button-prev',
            },
            pagination: {
              el: '.product .product__pagination',
              type: 'custom',
              renderCustom: (e, t, i) => {
                let s = '';
                for (let e = 1; e < i + 1; e++) {
                  s +=
                    e == t
                      ? `<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`
                      : `<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
                }
                return s;
              },
            },
            thumbs: {
              swiper: document.querySelectorAll('.js-media-sublist')[i]?.swiper || '',
            },
            on: {
              slideChange() {
                window.pauseAllMedia();
                this.params.noSwiping = false;
                if (document.querySelector('.js-popup-slider')?.swiper) {
                  document.querySelector('.js-popup-slider').swiper.slideTo(this.activeIndex);
                }
              },
              slideChangeTransitionEnd() {
                this.slides[this.activeIndex]
                  .querySelector('model-viewer')
                  ?.querySelector('.shopify-model-viewer-ui__button--poster')
                  .removeAttribute('hidden');
              },
              touchStart() {
                const mv = this.slides[this.activeIndex].querySelector('model-viewer');
                if (mv) {
                  if (mv.classList.contains('shopify-model-viewer-ui__disabled')) {
                    this.params.noSwiping = false;
                  } else {
                    this.params.noSwiping = true;
                    this.params.noSwipingClass = 'swiper-slide';
                  }
                }
              },
            },
          });
          if (n) setTimeout(() => swiper.update(), 800);
        }
      }).observe(mediaList.closest('.product__outer'));
    } else if (!mediaList.classList.contains('swiper-initialized')) {
      swiper = new Swiper(mediaList, {
        slidesPerView: 1,
        spaceBetween: 1,
        mousewheel: { forceToAxis: true },
        autoHeight: false,
        speed: 500,
        pagination: {
          el: '.product .product__pagination',
          type: 'custom',
          renderCustom: (e, t, i) => {
            let s = '';
            for (let e = 1; e < i + 1; e++) {
              s +=
                e == t
                  ? `<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`
                  : `<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
            }
            return s;
          },
        },
        thumbs: {
          swiper: document.querySelectorAll('.js-media-sublist')[i]?.swiper || '',
        },
        on: {
          slideChange() {
            window.pauseAllMedia();
            this.params.noSwiping = false;
            if (document.querySelector('.js-popup-slider')?.swiper) {
              document.querySelector('.js-popup-slider').swiper.slideTo(this.activeIndex);
            }
          },
          slideChangeTransitionEnd() {
            this.slides[this.activeIndex]
              .querySelector('model-viewer')
              ?.querySelector('.shopify-model-viewer-ui__button--poster')
              .removeAttribute('hidden');
          },
          touchStart() {
            const mv = this.slides[this.activeIndex].querySelector('model-viewer');
            if (mv) {
              if (mv.classList.contains('shopify-model-viewer-ui__disabled')) {
                this.params.noSwiping = false;
              } else {
                this.params.noSwiping = true;
                this.params.noSwipingClass = 'swiper-slide';
              }
            }
          },
        },
      });
      swiper.activeFilters = {
        color: mediaList.dataset?.color || null,
        variant: mediaList.dataset?.variant || null,
      };

      filterSlides(swiper);

      if (n) setTimeout(() => swiper.update(), 800);
    }
  });
};
let subSliderInit = (a) => {
  document.querySelectorAll('.js-media-sublist').forEach((mediaSublist) => {
    let direction = 'vertical',
      autoHeight = true,
      slidesPerView = 'auto',
      slidesPerViewTab = 'auto';
    if (mediaSublist.classList.contains('js-media-sublist--horizontal')) {
      direction = 'horizontal';
      autoHeight = false;
      slidesPerView = 4;
      slidesPerViewTab = 3;
    }
    const swiper = new Swiper(mediaSublist, {
      slidesPerView: slidesPerViewTab,
      spaceBetween: 8,
      direction: direction,
      autoHeight: autoHeight,
      mousewheel: { forceToAxis: true },
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      navigation: {
        nextEl: '.product .product__slider-nav .swiper-button-next',
        prevEl: '.product .product__slider-nav .swiper-button-prev',
      },
      breakpoints: {
        750: { slidesPerView: slidesPerView },
        990: { slidesPerView: slidesPerViewTab },
        1200: { slidesPerView: slidesPerView },
      },
      on: {
        touchEnd(e) {
          const t = e.isHorizontal() ? e.touches.currentX - e.touches.startX : e.touches.currentY - e.touches.startY;
          if (Math.abs(t) < 5) e.allowClick = true;
        },
      },
    });
    if (a) setTimeout(() => swiper.update(), 800);
  });
};
let popupSliderInit = (t) => {
  const popup = document.querySelector('.js-popup-slider');
  if (popup) {
    const e = new Swiper(popup, {
      slidesPerView: 1,
      mousewheel: { forceToAxis: true },
      navigation: {
        nextEl: '.product-media-modal .product__slider-nav .swiper-button-next',
        prevEl: '.product-media-modal .product__slider-nav .swiper-button-prev',
      },
      on: {
        afterInit() {
          if (
            document.querySelector('.product__outer--grid-gallery') ||
            document.querySelector('.product__outer--stacked-gallery')
          ) {
            document.querySelectorAll('.product__media-list .product__media-toggle').forEach((btn, t) => {
              btn.addEventListener('click', () => {
                popup.swiper?.slideTo(t);
              });
            });
          }
        },
        slideChange() {
          window.pauseAllMedia();
          this.params.noSwiping = false;
          document.querySelector('.product-media-modal__content')?.classList.remove('zoom');
        },
        touchMove() {
          document.querySelector('.product-media-modal__content')?.classList.remove('zoom');
        },
        slideChangeTransitionEnd() {
          this.slides[this.activeIndex]
            .querySelector('model-viewer')
            ?.querySelector('.shopify-model-viewer-ui__button--poster')
            .removeAttribute('hidden');
        },
        touchStart() {
          const mv = this.slides[this.activeIndex].querySelector('model-viewer');
          if (mv) {
            if (mv.classList.contains('shopify-model-viewer-ui__disabled')) {
              this.params.noSwiping = false;
            } else {
              this.params.noSwiping = true;
              this.params.noSwipingClass = 'swiper-slide';
            }
          }
        },
      },
    });
    if (t) setTimeout(() => e.update(), 800);
  }
};
let sliderQuickAddInit = (t) => {
  let s = t.querySelector('.product__media-list');
  if (!s) return;
  if (!s.classList.contains('swiper')) {
    s.classList.add('swiper');
    s.innerHTML = `<div class='swiper-wrapper'>${s.innerHTML}</div>`;
  }
  let e = new Swiper(s, {
    slidesPerView: 2,
    slidesPerGroup: 1,
    mousewheel: { forceToAxis: true },
    spaceBetween: 8,
    speed: 500,
    navigation: {
      nextEl: t.querySelector('.product__slider-nav .swiper-button-next'),
      prevEl: t.querySelector('.product__slider-nav .swiper-button-prev'),
    },
    pagination: {
      el: t.querySelector('.product__pagination'),
      type: 'custom',
      renderCustom: (e, t, i) => {
        let s = '';
        for (let e = 1; e <= i; e++) {
          s +=
            e == t
              ? `<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`
              : `<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
        }
        return s;
      },
    },
    breakpoints: {
      750: { slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 0 },
    },
    on: {
      slideChangeTransitionStart() {
        let main = document.querySelector('.product__media-list')?.swiper;
        if (main) main.slideTo(this.activeIndex);
      },
      slideChange() {
        window.pauseAllMedia();
        this.params.noSwiping = false;
      },
      slideChangeTransitionEnd() {
        this.slides[this.activeIndex]
          .querySelector('model-viewer')
          ?.querySelector('.shopify-model-viewer-ui__button--poster')
          .removeAttribute('hidden');
      },
      touchStart() {
        const mv = this.slides[this.activeIndex].querySelector('model-viewer');
        if (mv) {
          if (mv.classList.contains('shopify-model-viewer-ui__disabled')) {
            this.params.noSwiping = false;
          } else {
            this.params.noSwiping = true;
            this.params.noSwipingClass = 'swiper-slide';
          }
        }
      },
    },
  });
  setTimeout(() => e.update(), 800);
};
let impactSliderInit = (t) => {
  const impact = document.querySelector('.js-impact-slider');
  if (impact) {
    const e = new Swiper(impact, {
      slidesPerView: 1.2,
      mousewheel: { forceToAxis: true },
      autoHeight: false,
      spaceBetween: 7,
      breakpoints: {
        750: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
      },
    });
    e.activeFilters = {
      color: impact.dataset?.color || null,
      variant: impact.dataset?.variant || null,
    };
    if (t) setTimeout(() => e.update(), 800);
  }
};

function getFocusableElements(e) {
  return Array.from(
    e.querySelectorAll(
      // eslint-disable-next-line quotes
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function camelize(str) {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, '');
}

function pascalize(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, (word) => word.toUpperCase()).replace(/\s+/g, '');
}

function ResetFilterSlides(swiper) {
  const slides = swiper.el.querySelectorAll('.product__media-item, .product__media-subitem');
  slides.forEach((slide) => {
    slide.classList.toggle('hidden', false);
    slide.classList.toggle('swiper-slide', true);
  });
}

function filterSlides(swiper, color, variant) {
  if (swiper.activeFilters == undefined) {
    swiper.activeFilters = {};
  }
  if (color) {
    swiper.activeFilters.color = color;
  }
  if (variant) {
    swiper.activeFilters.variant = variant;
  }

  const slides = swiper.el.querySelectorAll('.product__media-item, .product__media-subitem');
  let activeSlides = 0;

  slides.forEach((slide, i) => {
    const slideColor = slide.dataset.color;
    const slideVariant = slide.dataset.variant;

    let match = true;
    if (
      swiper.activeFilters.color &&
      swiper.activeFilters.color != 'Default' &&
      slideColor?.toLowerCase() !== swiper.activeFilters.color.toLowerCase() &&
      !slideColor?.includes('Live') &&
      !slideColor?.includes('Default') &&
      !slideColor?.includes('Gif') &&
      !slideColor?.includes('GIF') &&
      !slideColor?.includes('Video') &&
      !slideColor?.includes('VIDEO') ||
      slideColor?.includes('Thumbnail')
    ) {
      match = false;
    }

    if (swiper.activeFilters.variant && slideVariant && slideVariant !== swiper.activeFilters.variant) {
      match = false;
    }

    slide.classList.toggle('hidden', !match);
    slide.classList.toggle('swiper-slide', match);
    if (match) {
      activeSlides++;
    }
  });

  if (activeSlides == 0) {
    ResetFilterSlides(swiper);
  } else if (activeSlides == 1) {
    swiper.thumbs?.swiper?.el.classList.add('visibility-hidden');
    swiper.thumbs?.swiper?.navigation?.nextEl?.classList.add('visibility-hidden');
    swiper.thumbs?.swiper?.navigation?.prevEl?.classList.add('visibility-hidden');
  } else {
    swiper.thumbs?.swiper?.el.classList.remove('visibility-hidden');
    swiper.thumbs?.swiper?.navigation?.nextEl?.classList.remove('visibility-hidden');
    swiper.thumbs?.swiper?.navigation?.prevEl?.classList.remove('visibility-hidden');
  }

  swiper.update();

  if (swiper.thumbs?.swiper) {
    filterSlides(swiper.thumbs.swiper, swiper.activeFilters.color, swiper.activeFilters.variant);
  }
}

function onKeyUpEscape(e) {
  if (e.code.toUpperCase() !== 'ESCAPE') return;
  let details = e.target.closest('details[open]');
  if (!details) return;
  let summary = details.querySelector('summary');
  details.removeAttribute('open');
  summary.setAttribute('aria-expanded', 'false');
  summary.focus();
}
if (navigator.userAgent.includes('iPhone')) {
  document
    .querySelector('[name=viewport]')
    ?.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1');
}

document.querySelectorAll('[id^="Details-"] summary').forEach((e) => {
  e.setAttribute('role', 'button');
  e.setAttribute('aria-expanded', 'false');
  e.nextElementSibling?.getAttribute('id') && e.setAttribute('aria-controls', e.nextElementSibling.id);
  e.addEventListener('click', (ev) => {
    ev.currentTarget.setAttribute('aria-expanded', !ev.currentTarget.closest('details').hasAttribute('open'));
  });
  e.closest('header-drawer') || e.parentElement.addEventListener('keyup', onKeyUpEscape);
});

let trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  let focusable = getFocusableElements(container),
    first = focusable[0],
    last = focusable[focusable.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = (e) => {
    if (e.target === first || e.target === last || e.target === container) {
      document.addEventListener('keydown', trapFocusHandlers.keydown);
    }
  };
  trapFocusHandlers.focusout = () => {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = (e) => {
    if (e.code.toUpperCase() === 'TAB') {
      if (e.target === last && !e.shiftKey) {
        e.preventDefault();
        first.focus();
      }
      if ((e.target === container || e.target === first) && e.shiftKey) {
        e.preventDefault();
        last.focus();
      }
    }
  };
  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  elementToFocus?.focus();
}

function removeTrapFocus(focusElement = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (focusElement && !focusElement.classList.contains('card-focused')) {
    focusElement.focus();
  }
}

window.pauseAllMedia = async function (i) {
  let videos = document.querySelectorAll('deferred-media video'),
    iframes = document.querySelectorAll('deferred-media iframe'),
    models = document.querySelectorAll('deferred-media model-viewer');
  let promises = [];
  videos.forEach((v) => {
    if (v !== i) {
      let p = v.pause();
      if (p !== undefined) promises.push(p);
    }
  });
  iframes.forEach((f) => {
    let src = f.src;
    if (f !== i) {
      if (src && src.includes('youtube.com')) {
        f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      } else if (src && src.includes('vimeo.com')) {
        let p = new Vimeo.Player(f).pause();
        if (p !== undefined) promises.push(p);
      }
    }
  });
  models.forEach((m) => {
    if (m !== i) {
      let ui = m.modelViewerUI;
      if (ui && typeof ui.pause === 'function') {
        let p = ui.pause();
        if (p !== undefined) promises.push(p);
      }
    }
  });
  return Promise.all(promises);
};

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) => {
      this.setMinimumDisable();
      button.addEventListener('click', this.onButtonClick.bind(this));
    });

    for (const event of ['paste', 'input']) {
      this.input.addEventListener(event, (e) => {
        const val = e.currentTarget.value;
        if (!/^0*?[1-9]\d*$/.test(val) && val !== '') {
          e.currentTarget.value = 1;
        }
        if (e.currentTarget.value === '1' || e.currentTarget.value === '') {
          this.input.previousElementSibling.classList.add('disabled');
        } else {
          this.input.previousElementSibling.classList.remove('disabled');
        }
      });
    }

    this.input.addEventListener('focusout', (e) => {
      if (e.currentTarget.value === '') e.currentTarget.value = 1;
    });
  }

  setMinimumDisable() {
    if (this.input.value == 1) {
      this.querySelector('button[name="minus"]').classList.add('disabled');
    } else {
      this.querySelector('button[name="minus"]').classList.remove('disabled');
    }
  }

  onButtonClick(e) {
    e.preventDefault();
    const oldValue = this.input.value;
    if (e.target.name === 'plus') {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }
    if (oldValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
    this.setMinimumDisable();
  }
}

function debounce(fn, delay) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), delay);
  };
}

customElements.define('quantity-input', QuantityInput);

let serializeForm = (e) => {
  var t,
    i = {},
    s = new FormData(e);
  for (t of s.keys()) i[t] = s.get(t);
  return JSON.stringify(i);
};
function fetchConfig(e = 'json') {
  return { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/' + e } };
}
void 0 === window.Shopify && (window.Shopify = {}),
  (Shopify.bind = function (e, t) {
    return function () {
      return e.apply(t, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (e, t) {
    for (var i = 0, s = e.options.length; i < s; i++) {
      var n = e.options[i];
      if (t == n.value || t == n.innerHTML) return (e.selectedIndex = i);
    }
  }),
  (Shopify.addListener = function (e, t, i) {
    e.addEventListener ? e.addEventListener(t, i, !1) : e.attachEvent('on' + t, i);
  }),
  (Shopify.postLink = function (e, t) {
    var i,
      s = (t = t || {}).method || 'post',
      n = t.parameters || {},
      o = document.createElement('form');
    for (i in (o.setAttribute('method', s), o.setAttribute('action', e), n)) {
      var a = document.createElement('input');
      a.setAttribute('type', 'hidden'), a.setAttribute('name', i), a.setAttribute('value', n[i]), o.appendChild(a);
    }
    document.body.appendChild(o), o.submit(), document.body.removeChild(o);
  }),
  (Shopify.CountryProvinceSelector = function (e, t, i) {
    (this.countryEl = document.getElementById(e)),
      (this.provinceEl = document.getElementById(t)),
      (this.provinceContainer = document.getElementById(i.hideElement || t)),
      Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this)),
      this.initCountry(),
      this.initProvince();
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var e = this.countryEl.getAttribute('data-default');
      Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
    },
    initProvince: function () {
      var e = this.provinceEl.getAttribute('data-default');
      e && 0 < this.provinceEl.options.length && Shopify.setSelectorByValue(this.provinceEl, e);
    },
    countryHandler: function (e) {
      var t = (s = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute('data-provinces'),
        i = JSON.parse(t);
      if ((this.clearOptions(this.provinceEl), i && 0 == i.length)) this.provinceContainer.style.display = 'none';
      else {
        for (var s, n = 0; n < i.length; n++)
          ((s = document.createElement('option')).value = i[n][0]),
            (s.innerHTML = i[n][1]),
            this.provinceEl.appendChild(s);
        this.provinceContainer.style.display = '';
      }
    },
    clearOptions: function (e) {
      for (; e.firstChild; ) e.removeChild(e.firstChild);
    },
    setOptions: function (e, t) {
      var i = 0;
      for (t.length; i < t.length; i++) {
        var s = document.createElement('option');
        (s.value = t[i]), (s.innerHTML = t[i]), e.appendChild(s);
      }
    },
  });
class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    const summaries = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaries);

    if (navigator.platform === 'iPhone') {
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    if (this.mainDetailsToggle.classList.contains('menu-drawer-container')) {
      document
        .querySelectorAll('[data-open-drawer]')
        .forEach((button) => button.addEventListener('click', this.openMenuDrawerWithButton.bind(this)));
    }
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );

    this.querySelectorAll('button').forEach((button) => {
      const ignoreSelectors = [
        '.toggle-scheme-button',
        '.header__localization-button',
        '.header__localization-lang-button',
        '.mobile-localization-form__back--reg',
        '.mobile-localization-form__back--lang',
      ];

      if (!ignoreSelectors.some((sel) => button.matches(sel))) {
        button.addEventListener('click', this.onCloseButtonClick.bind(this));
      }
    });
  }

  addAccessibilityAttributes(summaries) {
    summaries.forEach((summary) => {
      summary.setAttribute('role', 'button');
      summary.setAttribute('aria-expanded', 'false');
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetails = event.target.closest('details[open]');
    if (!openDetails) return;

    if (openDetails === this.mainDetailsToggle) {
      this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary'));
    } else {
      this.closeSubmenu(openDetails);
    }
  }

  onSummaryClick(event) {
    const summary = event.currentTarget;
    const details = summary.parentNode;
    const isOpen = details.hasAttribute('open');

    if (details === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summary) : this.openMenuDrawer(summary);
    } else {
      trapFocus(summary.nextElementSibling, details.querySelector('button'));
      setTimeout(() => details.classList.add('menu-opening'));
    }
  }

  openMenuDrawer(summary) {
    setTimeout(() => this.mainDetailsToggle.classList.add('menu-opening'));
    summary.setAttribute('aria-expanded', 'true');
    trapFocus(this.mainDetailsToggle, summary);
    document.body.classList.add('overflow-hidden-drawer');
  }

  openMenuDrawerWithButton(event) {
    event.preventDefault();
    this.mainDetailsToggle.querySelector('summary')?.click();
  }

  closeMenuDrawer(summary, focusAfter) {
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((sub) => {
      sub.removeAttribute('open');
      sub.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden-drawer');
    removeTrapFocus(focusAfter);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    const backButtonClass = 'mobile-localization-form__back';
    if (event.relatedTarget?.classList.contains(backButtonClass)) return;

    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) {
        this.closeMenuDrawer();
      }
    });
  }

  onCloseButtonClick(event) {
    const details = event.currentTarget.closest('details');
    this.closeSubmenu(details);
  }

  closeSubmenu(details) {
    details.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(details);
  }

  closeAnimation(details) {
    let start;
    const step = (timestamp) => {
      start = start || timestamp;
      if (timestamp - start < 400) {
        window.requestAnimationFrame(step);
      } else {
        details.removeAttribute('open');
        const parentOpen = details.closest('details[open]');
        if (!details.closest('.burger-menu') && parentOpen) {
          trapFocus(parentOpen, details.querySelector('summary'));
        }
      }
    };
    window.requestAnimationFrame(step);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }
  openMenuDrawer(e) {
    this.headerWrapper = document.querySelector('.header-wrapper');
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.headerWrapper.getBoundingClientRect().top)}px`
    );
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    e.setAttribute('aria-expanded', !0);
    trapFocus(this.mainDetailsToggle, e);
    document.body.classList.add('overflow-hidden-drawer');
  }
}
customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    const closeBtn = this.querySelector('[id^="ModalClose-"]');
    closeBtn?.addEventListener('click', () => this.hide(false));
    this.addEventListener('keyup', ({ code }) => {
      if (code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', ({ pointerType, target }) => {
        if (pointerType === 'mouse' && !target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', ({ target }) => {
        if (target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (!this.moved) {
      this.moved = true;
      document.body.appendChild(this);
    }
  }

  show(trigger) {
    this.openedBy = trigger;
    const content = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden-modal');
    this.setAttribute('open', '');
    content?.loadContent?.();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia?.();
  }

  hide(restoreFocus = true) {
    this.removeAttribute('open');
    removeTrapFocus(restoreFocus ? this.openedBy : null);
    window.pauseAllMedia?.();
    if (!document.querySelector('body > quick-add-modal[open]')) {
      document.body.classList.remove('overflow-hidden-modal');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
    }
    const zoomEl = document.querySelector('.product-media-modal__content');
    zoomEl?.classList.remove('zoom');
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (button) {
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        modal?.show(button);
      });
    }
  }
}
customElements.define('modal-opener', ModalOpener);

class ModalOpenerQuickView extends HTMLElement {
  constructor() {
    super();
    let t = this.querySelector('button');
    t &&
      t.addEventListener('click', () => {
        let e = document.createElement('quick-add-modal');
        (e.id = t.dataset.modalId),
          (e.className = t.dataset.modalClass),
          (e.innerHTML = `<div role="dialog" aria-label="Choose options for ${t.dataset.modalAriaLabel}" aria-modal="true" class="quick-add-modal__content global-settings-popup js-mobile-swipe js-mobile-swipe-down">
            <div class="quick-add-modal__control js-mobile-swipe-control">
              <svg width="38" height="3" viewBox="0 0 38 3" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-mobile-swipe">
                <rect width="38" height="3" rx="1.5" fill="currentColor"/>
              </svg>
            </div>
            <button id="ModalClose-${t.dataset.productId}" type="button" class="quick-add-modal__toggle modal-close-button" aria-label="Close" tabindex="-1">
              <svg class="icon icon-close" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.99989 9.31163L2.29175 15.0198L0.980116 13.7081L6.68826 8L0.980116 2.29186L2.29175 0.980222L7.99989 6.68837L13.708 0.980222L15.0197 2.29186L9.31153 8L15.0197 13.7081L13.708 15.0198L7.99989 9.31163Z" fill="currentColor"/>
              </svg>
            </button>
            <div class="quick-add-modal__content-wrapper">
              <div id="QuickAddInfo-${t.dataset.productId}" class="quick-add-modal__content-info"></div>
            </div>
          </div>`),
          (e.moved = !0),
          (e.modalContent = e.querySelector('[id^="QuickAddInfo-"]')),
          (e.closeButton = e.querySelector('[id^="ModalClose-"]')),
          e.closeButton?.addEventListener('click', () => e.hide(!1)),
          new SwipeMobile(e.querySelector('.js-mobile-swipe'), 'down', 160, 400, () => e.hide(!0)),
          document.body.append(e),
          e.show(t);
      });
  }
}
customElements.define('modal-opener-quick-view', ModalOpenerQuickView);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    var e = this.querySelector('[id^="Deferred-Poster-"]');
    e && e.addEventListener('click', () => this.loadContent(!0));
  }
  loadContent(t = !0) {
    if ((window.pauseAllMedia(), !this.getAttribute('loaded'))) {
      var i = this.querySelector('template');
      if (i && i.content && i.content.firstElementChild) {
        var s = document.createElement('div');
        s.appendChild(i.content.firstElementChild.cloneNode(!0)), this.setAttribute('loaded', !0);
        let e = this.appendChild(s.firstElementChild);
        e instanceof HTMLVideoElement
          ? e.addEventListener('play', () => window.pauseAllMedia(e))
          : e instanceof HTMLIFrameElement
          ? (i = e.src) && i.includes('youtube.com')
            ? e.addEventListener('load', () => {
                e.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*'),
                  e.parentElement.addEventListener('click', () => window.pauseAllMedia(e));
              })
            : i &&
              i.includes('vimeo.com') &&
              e.addEventListener('load', () => {
                new Vimeo.Player(e).on('play', () => window.pauseAllMedia(e)),
                  e.parentElement.addEventListener('click', () => window.pauseAllMedia(e));
              })
          : 'model-viewer' === e.tagName.toLowerCase()
          ? e.addEventListener('load', () => {
              window.pauseAllMedia(e);
            })
          : console.error('Unsupported media element or HTMLModelViewerElement is null'),
          t && (e.focus(), e instanceof HTMLVideoElement) && e.autoplay && e.play().catch(console.error);
      } else console.error('Template or its content is missing.');
    }
  }
}
customElements.define('deferred-media', DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateVariantStatuses();
    if (this.currentVariant) {
      this.filterMedia(this.currentVariant.title);
      this.updateURL();
      this.updateVariantInput();
      this.updateColorScheme(this.currentVariant);
      this.renderProductInfo();
    } else {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (el) => el.value);
  }

  updateColorScheme(variant) {
    if (!cscoDarkMode || !variant) return;

    /* The swatch's own flag wins; without one, titanium is the dark finish. It
       arrives from Liquid as a string, and an absent flag must not be read as
       "light" - that would force light on products with no swatch data. */
    const flagged = variant.dark_mode !== undefined;
    if (!flagged && !variant.material) return;

    const dark = flagged ? variant.dark_mode === 'true' : variant.material == 'Titanium';
    cscoDarkMode.changeScheme(dark ? 'dark' : 'light', false);
  }

  updateMasterId() {
    const data = this.getVariantData();
    this.currentVariant = data.find((variant) => variant.options.every((opt, idx) => this.options[idx] === opt));
    this.updateAbconvertPriceForCurrentVariant();
  }

  updateAbconvertPriceForCurrentVariant() {
    try {
      if (!this.currentVariant || !window.abconvertPriceCartTransformTestDict) return;
      const productId = this.currentVariant.featured_image?.product_id?.toString();
      const variantId = this.currentVariant.id?.toString();
      const abData = window.abconvertPriceCartTransformTestDict[productId];
      if (!abData?.experimentId) return;

      const countryCode = Shopify?.country;
      if (abData.filteredCountriesMap && countryCode) {
        if (!abData.filteredCountriesMap[countryCode]) return;
      }

      let groupIndex = 0;
      const testGroupsRaw = localStorage.getItem('abconvert-experiment-to-group-index');
      if (testGroupsRaw) {
        const testGroups = JSON.parse(testGroupsRaw);
        let idx = testGroups?.[abData.experimentId];
        if (typeof idx !== 'undefined') {
          groupIndex = typeof idx === 'string' ? parseInt(idx, 10) : idx;
        }
      }

      const priceObj = abData.variantToGroupIndexToPrice?.[variantId]?.[groupIndex];
      if (!priceObj) return;

      const updatePriceFields = (obj) => {
        if (obj.price) {
          this.currentVariant.price = Math.round(parseFloat(obj.price) * 100);
        }
        if (
          typeof obj.compareAtPrice !== 'undefined' &&
          obj.compareAtPrice !== null &&
          obj.compareAtPrice !== ''
        ) {
          this.currentVariant.compare_at_price = Math.round(parseFloat(obj.compareAtPrice) * 100);
        }
      };

      if (countryCode && priceObj.countryMap && priceObj.countryMap[countryCode]) {
        updatePriceFields(priceObj.countryMap[countryCode]);
      } else {
        updatePriceFields(priceObj);
      }
    } catch (e) {
      // ignore errors
    }
  }

  getVariantData() {
    if (!this.variantData) {
      const json = this.querySelector('[type="application/json"]');
      if (json) this.variantData = JSON.parse(json.textContent);
    }
    return this.variantData;
  }

  updateMedia(mediaId) {
    const section = document.querySelector(`[data-section="main-${this.dataset.section}"]`);
    const list = section.querySelector('.product__media-list');
    const media = list.querySelector(`[data-media-id="${mediaId}"]`);
    list.querySelectorAll('[data-media-id]').forEach((el) => el.classList.remove('active'));
    media?.classList.add('active');

    document.querySelectorAll('.product__media-wrapper').forEach((wrapper) => {
      if (window.getComputedStyle(wrapper).display !== 'none') {
        const activeMedia = wrapper.querySelector(
          `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );
        const swiper = wrapper.querySelector('.product__media-list')?.swiper;
        swiper && swiper.slideTo(swiper.slides.indexOf(activeMedia));
      }
    });
  }

  filterMedia(variantTitle) {
    document.querySelectorAll('.product__media-wrapper').forEach((wrapper) => {
      if (window.getComputedStyle(wrapper).display !== 'none') {
        variantTitle = pascalize(variantTitle)
          .replace(/Aluminum|Titanium|Lisa/gi, '')
          .trim();
        const swiper = wrapper.querySelector('.product__media-list')?.swiper;
        if (swiper) {
          filterSlides(swiper, null, variantTitle);
        }
      }
    });
  }

  updateURL() {
    if (
      !this.classList.contains('featured-product-radios') &&
      this.currentVariant &&
      this.dataset.updateUrl !== 'false'
    ) {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('variant', this.currentVariant.id);

      window.history.replaceState({}, '', currentUrl.toString());
    }
  }

  updateVariantInput() {
    const formSelectors = this.dataset.index
      ? `#product-form-${this.dataset.section}-${this.dataset.index}, #product-form-installment-${this.dataset.section}-${this.dataset.index}`
      : `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`;
    document.querySelectorAll(formSelectors).forEach((form) => {
      const input = form.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const group = this.variantData.filter((v) => this.querySelector(':checked').value === v.option1);
    const controls = [...this.querySelectorAll('.product-form__controls')];
    controls.forEach((control, i) => {
      if (i === 0) return;
      const inputs = [...control.querySelectorAll('input[type="radio"], option')];
      const prevValue = controls[i - 1].querySelector(':checked').value;
      const available = group
        .filter((v) => v.available && v[`option${i}`] === prevValue)
        .map((v) => v[`option${i + 1}`]);
      this.setInputAvailability(inputs, available);
    });
  }

  setInputAvailability(inputs, availableValues) {
    inputs.forEach((input) => {
      const value = input.getAttribute('value');
      if (availableValues.includes(value)) {
        if (input.tagName === 'OPTION') input.innerText = value;
        else input.classList.remove('disabled');
      } else {
        if (input.tagName === 'OPTION')
          input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', value);
        else input.classList.add('disabled');
      }
    });
  }

  updatePickupAvailability() {
    const pickup = document.querySelector('pickup-availability');
    if (!pickup) return;
    if (this.currentVariant && this.currentVariant.available) {
      pickup.fetchAvailability(this.currentVariant.id);
    } else {
      pickup.removeAttribute('available');
      pickup.innerHTML = '';
    }
  }

  renderProductInfo() {
    const id = this.currentVariant.id;
    const sectionId = this.dataset.originalSection || this.dataset.section;
    fetch(`${this.dataset.url}?variant=${id}&section_id=${sectionId}`)
      .then((res) => res.text())
      .then((html) => {
        if (this.currentVariant.id !== id) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const isFeatured = doc.querySelector('.featured-product-slideshow-section');
        const index = this.dataset.index;

        const getId = (prefix, section) => `${prefix}-${section}${index ? '-' + index : ''}`;
        const fromDoc = (id) => doc.getElementById(id);
        const toDoc = (id) => document.getElementById(id);

        const price = fromDoc(getId('price', sectionId));
        const sku = fromDoc(getId('Sku', sectionId));
        const inventory = fromDoc(getId('Inventory', sectionId));
        const textBlock = fromDoc(getId('TextBlock', sectionId));
        const shippingBlock = fromDoc(getId('ShippingNote', sectionId));
        const customBadges = fromDoc(getId('CustomBadges', sectionId));

        const priceEl = toDoc(getId('price', this.dataset.section));
        const skuEl = toDoc(getId('Sku', this.dataset.section));
        const invEl = toDoc(getId('Inventory', this.dataset.section));
        const textBlockEl = toDoc(getId('TextBlock', this.dataset.section));
        const shippingBlockEl = toDoc(getId('ShippingNote', this.dataset.section));
        const customBadgesEl = toDoc(getId('CustomBadges', this.dataset.section));

        /* The fresh section carries every PDP upsell test variant, but the page only
           keeps one (pdp-upsell-test.js) - and the Impact block has a colour label
           of its own. Skip labels in variants this page has removed, or the counts
           below never match and no colour label updates at all. */
        const upsellTest = document.documentElement.dataset.pdpUpsellResolved
          ? document.documentElement.dataset.pdpUpsell
          : null;
        const fromColors = Array.from(
          doc.querySelectorAll(`[data-color-name-id="ColorName-${sectionId}${index ? '-' + index : ''}"]`)
        ).filter((el) => {
          const testBlock = upsellTest && el.closest('[data-upsell-test]');
          return !testBlock || testBlock.dataset.upsellTest === upsellTest;
        });
        const toColors = document.querySelectorAll(
          `[data-color-name-id="ColorName-${
            this.dataset.originalSection && !this.closest('quick-add-modal')
              ? this.dataset.originalSection
              : this.dataset.section
          }${index ? '-' + index : ''}"]`
        );

        const fromDescription = doc.querySelectorAll('[data-variant-description]');
        const toDescription = document.querySelectorAll('[data-variant-description]');

        fromColors.length === toColors.length && toColors.forEach((el, i) => (el.innerHTML = fromColors[i].innerHTML));
        fromDescription.length === toDescription.length &&
          toDescription.forEach((el, i) => (el.innerHTML = fromDescription[i].innerHTML));
        if (price && priceEl) priceEl.innerHTML = price.innerHTML;
        if (inventory && invEl) invEl.innerHTML = inventory.innerHTML;
        if (textBlock && textBlockEl) textBlockEl.innerHTML = textBlock.innerHTML;
        if (shippingBlock && shippingBlockEl) shippingBlockEl.innerHTML = shippingBlock.innerHTML;
        if (customBadges && customBadgesEl) customBadgesEl.innerHTML = customBadges.innerHTML;
        /* Every kit still on the page, matched to its fresh copy by block id - the PDP
           upsell test puts several kits in one section, each wrapper id ending in its
           block id. A kit pdp-upsell-test.js has removed is not in the document, so it
           is never brought back. */
        const kitPrefix = `ComplementaryKit-${this.dataset.section}-`;
        document.querySelectorAll(`[data-complementary-kit][id^="${kitPrefix}"]`).forEach((kitEl) => {
          const kit = fromDoc(`ComplementaryKit-${sectionId}-${kitEl.id.slice(kitPrefix.length)}`);
          if (kit) kitEl.innerHTML = kit.innerHTML;
        });
        if (sku && skuEl) {
          skuEl.innerHTML = sku.innerHTML;
          skuEl.classList.toggle('visibility-hidden', sku.classList.contains('visibility-hidden'));
        }
        if (priceEl) priceEl.classList.remove('visibility-hidden');
        if (invEl) invEl.classList.toggle('visibility-hidden', inventory?.innerText === '');

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        this.updatePrice();

        publish(PUB_SUB_EVENTS.variantChange, { data: { sectionId: this.dataset.section, variant: this.currentVariant } });
      });
  }

  shopifyStyleRound(price) {
    const cents = Math.round(price * 1000) / 10;
    const remainder = cents % 100;

    if (remainder === 50) {
      return Math.ceil(price);
    }

    return +price.toFixed(2);
  }

  updatePrice() {
    if (!this.currentVariant) {
      this.updateOptions();
      this.updateMasterId();
      if (!this.currentVariant) return;
    }
    const impactVars = document.querySelector('impact-variant-radios');

    const index = this.dataset.index;
    const sectionId = this.dataset.originalSection || this.dataset.section;
    const priceId = `#price-${sectionId}${index ? '-' + index : ''}`;

    const priceWraps = document.querySelectorAll(`${priceId} .price__last :is(.transcy-money, .price-item:not(:has(.transcy-money)))`);
    const comparePriceWraps = document.querySelectorAll(`${priceId}  .price__compare :is(.transcy-money, .price-item:not(:has(.transcy-money)))`);

    if (impactVars?.currentFreePrice) return;

    let finalPrice = Number(this.currentVariant.price) || 0;
    let finalComparePrice = Number(this.currentVariant.compare_at_price) || 0;

    if (impactVars?.currentVariant) {
      finalPrice += Number(impactVars.currentVariant.price) || 0;
      if (finalComparePrice && impactVars.currentVariant.compare_at_price) {
        finalComparePrice += Number(impactVars.currentVariant.compare_at_price) || 0;
      }
    }

    if (this.currentVariant.bundle_full_price) {
      finalComparePrice = Number(this.currentVariant.bundle_full_price) || 0;
    }

    if (this.currentVariant?.global_sale_percent > 0) {
      finalComparePrice = finalPrice;
      finalPrice = this.shopifyStyleRound(finalPrice * (1 - (this.currentVariant.global_sale_percent / 100)));
    }

    const productKit = document.querySelector(`product-kit[data-form-id="product-form-${sectionId}"]`);
    if (productKit?.hasSelection) {
      finalComparePrice = (finalComparePrice || finalPrice) + productKit.compareTotal;
      finalPrice += productKit.total;
    }

    const priceElement = document.querySelector(`${priceId} .price`);
    if (priceElement) priceElement.classList.toggle('price--on-sale', finalComparePrice > finalPrice);

    priceWraps.forEach((price) => (price.innerHTML = window.formatMoney(finalPrice)));
    comparePriceWraps.forEach((price) => (price.innerHTML = window.formatMoney(finalComparePrice)));
  }

  toggleAddButton(disable = true, text = '', unavailable = false) {
    const form = document.getElementById(
      this.dataset.index
        ? `product-form-${this.dataset.section}-${this.dataset.index}`
        : `product-form-${this.dataset.section}`
    );
    const button = form?.querySelector('[name="add"]');
    const span = button?.querySelector('span');

    if (!button || !span) return;

    if (!button.hasAttribute('disabled')) {
      this.liveAddLabel = span.textContent.trim() || this.liveAddLabel;
    }

    if (disable) {
      button.setAttribute('disabled', 'disabled');
      if (text) span.textContent = text;
    } else {
      button.removeAttribute('disabled');
      span.textContent = this.liveAddLabel || window.variantStrings.addToCart;
    }
  }

  setUnavailable() {
    const form = document.getElementById(
      this.dataset.index
        ? `product-form-${this.dataset.section}-${this.dataset.index}`
        : `product-form-${this.dataset.section}`
    );
    const button = form.querySelector('[name="add"]');
    const sku = document.getElementById(
      this.dataset.index ? `Sku-${this.dataset.section}-${this.dataset.index}` : `Sku-${this.dataset.section}`
    );
    const inventory = document.getElementById(
      this.dataset.index
        ? `Inventory-${this.dataset.section}-${this.dataset.index}`
        : `Inventory-${this.dataset.section}`
    );
    if (button) {
      this.toggleAddButton(true, window.variantStrings.unavailable);
    }
    sku?.classList.add('visibility-hidden');
    inventory?.classList.add('visibility-hidden');
  }
}
customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(inputs, availableValues) {
    inputs.forEach((input) => {
      input.classList.toggle('disabled', !availableValues.includes(input.getAttribute('value')));
    });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('fieldset')).map(
      (fs) => Array.from(fs.querySelectorAll('input')).find((input) => input.checked).value
    );
  }
}
customElements.define('variant-radios', VariantRadios);

class PasswordViewer {
  constructor() {
    document.querySelectorAll('.field--pass').forEach((e) => {
      let t = e.querySelector('input'),
        i = e.querySelector('.button-pass-visibility'),
        s = e.querySelector('.icon-eye-close'),
        n = e.querySelector('.icon-eye');
      t.addEventListener('input', () => {
        '' !== t.value ? (i.style.display = 'block') : (i.style.display = 'none');
      }),
        s.addEventListener('click', () => {
          (t.type = 'text'), (s.style.display = 'none'), (n.style.display = 'block');
        }),
        n.addEventListener('click', () => {
          (t.type = 'password'), (s.style.display = 'block'), (n.style.display = 'none');
        });
    });
  }
}
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    });
    this.intersectionObserver.observe(this);
  }
  handleIntersection(e, t) {
    e[0].isIntersecting &&
      (t.unobserve(this),
      this.showLoading(),
      this.loadRecommendations()
        .then((e) => {
          this.updateRecommendations(e), this.checkSwatches(), this.initSliders();
        })
        .catch((e) => {
          console.error('Error loading recommendations:', e);
        })
        .finally(() => {
          this.hideLoading();
        }));
  }
  showLoading() {
    var e = this.querySelector('.product-recommendations__loading');
    e && (e.classList.add('loading'), (e.style.display = 'flex'));
  }
  hideLoading() {
    var e = this.querySelector('.product-recommendations__loading');
    e && e.classList.remove('loading');
  }
  async loadRecommendations() {
    var e = await (await fetch(this.dataset.url)).text(),
      t = document.createElement('div');
    return (t.innerHTML = e), t;
  }
  updateRecommendations(e) {
    (e = e.querySelector('product-recommendations')),
      e && e.innerHTML.trim().length && (this.innerHTML = e.innerHTML),
      (e = this.querySelector('.product-recommendations__empty'));
    e && (e.style.display = 'flex');

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.items) {
        this.updatePrice(event.items, true);
      } else if (event?.productVariantId) {
        this.updatePrice([{ variant_id: event.productVariantId }], false);
      }
    });
  }
  // Each price element carries its own data-target-variants (the specific upsell
  // combo it depends on, from price.discounts.upsell_variants) - matches happen
  // per card, not for the whole recommendations widget.
  // authoritative: true when cartItems is the full cart (can turn the sale off
  // too); false when it's just the variant that was added just now (can only
  // ever turn the sale on, since we don't know the rest of the cart).
  updatePrice(cartItems, authoritative) {
    this.querySelectorAll('.price--product-button, .price--variant-selector').forEach((priceEl) => {
      const targetVariants = (priceEl.dataset.targetVariants || '').split(',').filter(Boolean);
      if (!targetVariants.length) return;

      const showSalePrice = cartItems.some((item) => targetVariants.includes(item.variant_id.toString()));
      if (!authoritative && !showSalePrice) return;

      const compareAtPrice = priceEl.querySelector('.price__compare .price-item--regular');
      const hasDiscount = compareAtPrice ? compareAtPrice.textContent.trim().length > 0 : false;
      priceEl.classList.toggle('price--on-sale', showSalePrice && hasDiscount);
      priceEl.classList.toggle('can-toggle-sale', showSalePrice);
    });
  }
  checkSwatches() {
    document.querySelectorAll('.js-color-swatches-wrapper').forEach((t) => {
      t.querySelectorAll('.js-color-swatches input').forEach((e) => {
        e.addEventListener('click', this.handleSwatchClick.bind(this, t, e));
      });
    });
  }
  handleSwatchClick(e, t) {
    var i,
      s,
      n,
      o,
      a = e.querySelector('.media--first'),
      r = e.querySelector('.media--second');
    t.checked &&
      a &&
      (e.querySelector('.js-color-swatches-link').setAttribute('href', t.dataset.variantLink),
      (i = e.querySelector('.card__add-to-cart button[name="add"]')),
      (s = e.querySelector('.card__add-to-cart button[name="add"] > span')),
      (n = e.querySelector('.card__add-to-cart button[name="add"] .sold-out-message')),
      (o = e.querySelector('.card__add-to-cart input[name="id"]')),
      i &&
        (i.setAttribute('aria-disabled', !1),
        s && s.classList.remove('hidden'),
        n && n.classList.add('hidden'),
        (o.value = t.dataset.variantId)),
      this.updateVariantImages(e, a, r, t.value));
  }
  async updateVariantImages(e, t, i, s) {
    try {
      var n = e.dataset.url,
        o = await fetch(n);
      if (!o.ok) throw new Error('Network response was not ok');
      var a = await o.json(),
        r = a.variants.find((e) => e.featured_media && e.options.includes(s));
      r && this.replaceImages(e, r, t, i, a.title);
    } catch (e) {
      console.error('There was a problem with the fetch operation:', e);
    }
  }
  replaceImages(e, t, i, s, n) {
    let o = this.createImageElement(t.featured_media, i.className, i.sizes, n);
    if (o.src !== i.src) {
      let e = !1;
      s &&
        new URL(s.src).pathname === new URL(o.src).pathname &&
        (i.remove(), s.classList.remove('media--second'), s.classList.add('media--first'), (e = !0)),
        e ||
          this.fadeOutImage(i, () => {
            i.parentNode.replaceChild(o, i), this.fadeInImage(o), s && s.remove();
          });
    }
  }
  fadeOutImage(e, t) {
    e.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200, easing: 'ease-in', fill: 'forwards' }).onfinish = t;
  }
  fadeInImage(e) {
    e.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: 'ease-in', fill: 'forwards' });
  }
  createImageElement(e, t, i, s) {
    var n = e.preview_image,
      o = new Image(n.width, n.height);
    return (
      (o.className = t),
      (o.alt = e.alt || s),
      (o.sizes = i),
      (o.src = n.src),
      (o.srcset = this.generateSrcset(n, [165, 360, 533, 720, 940, 1066])),
      (o.loading = 'lazy'),
      o
    );
  }
  generateSrcset(t, e) {
    let i = new URL(t.src);
    return e
      .filter((e) => e <= t.width)
      .map((e) => (i.searchParams.set('width', e.toString()), i.href + ` ${e}w`))
      .join(', ');
  }
  initSliders() {
    this.initSlider('.js-recommendation-swiper', this.setupRecommendationSlider.bind(this));
    const complementarySwiperEl = document.querySelector('.js-complementary-swiper');
    if (!complementarySwiperEl) return;
    new ResizeObserver((entries) => {
      this.setupComplementarySlider(complementarySwiperEl, entries[0].contentRect.width);
    }).observe(document.documentElement);
  }
  initSlider(e, t) {
    e = this.querySelector(e);
    e && t(e);
  }
  setupRecommendationSlider(e) {
    var t = this.querySelector('.product-recommendations__navigation'),
      i = this.querySelector('.product-recommendations__pagination'),
      s = Number(e.dataset.columns),
      n = s,
      o = 4 <= s ? n - 1 : n,
      a = 3 <= s ? 3 : n,
      r = 2 <= s ? 2 : a;
    let l = 1;
    e.classList.contains('products--2-mobile') && (l = 1 < s ? 2 : 1);
    r = {
      576: { slidesPerView: r, slidesPerGroup: r, spaceBetween: 8 },
      750: { slidesPerView: a, slidesPerGroup: a, spaceBetween: 8 },
      990: { slidesPerView: o, slidesPerGroup: o, spaceBetween: 8 },
      1200: { slidesPerView: n, slidesPerGroup: n, spaceBetween: 24 },
      1600: { slidesPerView: s, slidesPerGroup: s, spaceBetween: 24 },
    };
    new Swiper(e, {
      slidesPerView: l,
      slidesPerGroup: l,
      spaceBetween: 8,
      mousewheel: { forceToAxis: !0 },
      speed: 800,
      navigation: { nextEl: t.querySelector('.swiper-button-next'), prevEl: t.querySelector('.swiper-button-prev') },
      pagination: {
        el: i,
        type: 'custom',
        renderCustom: (e, t, i) => {
          let s = '';
          for (let e = 1; e <= i; e++)
            s += `<span class="swiper-pagination-bullet ${
              e === t ? 'swiper-pagination-bullet-active' : ''
            }" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
          return s;
        },
      },
      breakpoints: r,
    });
  }
  updateTitle(swiper) {
    const currentSlide = swiper.slides[swiper.activeIndex];
    const title = currentSlide?.querySelector('[data-recommendation-title]')?.dataset.recommendationTitle;
    const additionalInfo = this.querySelector('.additional-text');
    if (additionalInfo) {
      additionalInfo.textContent = title ? title : ' ';
    }
  }
  setupComplementarySlider(slider, width) {
    const this_el = this;
    if (width < 990) {
      if (this.complementarySlider) this.complementarySlider.destroy(true, true);

      slider.querySelector('.complementary-products__wrapper')?.classList.add('swiper-wrapper');
      slider.querySelectorAll('.complementary-products__slide').forEach((card) => card.classList.add('swiper-slide'));

      this.complementarySlider = new Swiper(slider, {
        spaceBetween: 8,
        mousewheel: { forceToAxis: !0 },
        speed: 800,
        paginationClickable: true,
        pagination: { el: slider.querySelector('.swiper-pagination'), type: 'bullets' },
        on: {
          init: this_el.updateTitle.bind(this),
          slideChange: this_el.updateTitle.bind(this),
        },
      });
      this.complementarySlider.pagination.update();
    } else {
      if (this.complementarySlider) {
        this.complementarySlider.destroy(true, true);
        this.complementarySlider = null;
      }
      slider.querySelector('.swiper-wrapper')?.classList.remove('swiper-wrapper');
      slider.querySelectorAll('.swiper-slide').forEach((card) => {
        card.classList.remove('swiper-slide');
        card.removeAttribute('style');
      });
    }
  }
}
function formatMoney(e, t = '') {
  'string' == typeof e && (e = e.replace('.', '')), (e = parseInt(e, 10));
  let i = '';
  var s = /\{\{\s*(\w+)\s*\}\}/,
    t = t || theme.moneyFormat;
  function n(e, t = 2, i = ',', s = '.') {
    return isNaN(e) || null == e
      ? '0'
      : (e = (e = (e / 100).toFixed(t)).split('.'))[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + i) +
          (0 < t ? s + e[1] : '');
  }
  var o = t.match(s);
  switch (o ? o[1] : 'amount') {
    case 'amount':
      i = n(e, 2, ',', '.');
      break;
    case 'amount_no_decimals':
      i = n(e, 0, ',', '.');
      break;
    case 'amount_with_comma_separator':
      i = n(e, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      i = n(e, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      // eslint-disable-next-line quotes
      i = n(e, 2, "'", '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      i = n(e, 0, ' ', '.');
      break;
    case 'amount_with_space_separator':
      i = n(e, 2, ' ', ',');
      break;
    case 'amount_with_period_and_space_separator':
      i = n(e, 2, ' ', '.');
      break;
    default:
      i = n(e, 2, ',', '.');
  }
  return t.replace(s, i);
}
customElements.define('product-recommendations', ProductRecommendations),
  (() => {
    var e = () => {
      let s = new IntersectionObserver((e) => {
          e.forEach((e) => {
            var t;
            e.isIntersecting
              ? void 0 !== (t = e.target.play()) && t.then((e) => {}).catch((e) => {})
              : e.target.pause();
          });
        }),
        i = (e, t) => {
          var i = e.querySelector('source');
          i
            ? i.src !== t && (t ? ((i.src = t), e.load(), s.unobserve(e), s.observe(e)) : (i.remove(), e.load()))
            : t && (((i = document.createElement('source')).type = 'video/mp4'), (i.src = t), e.append(i));
        },
        t = new ResizeObserver((e) => {
          e.forEach((e) => {
            var t;
            575 < document.body.clientWidth
              ? ((t = e.target.dataset.urlDesktop), i(e.target, t))
              : ((t = e.target.dataset.urlMobile), i(e.target, t));
          });
        });
      document.querySelectorAll('.js-dynamic-video').forEach((e) => {
        t.observe(e), s.observe(e);
      });
    };
    e(), document.addEventListener('shopify:section:load', e);
  })();
class LocalizationForm extends HTMLElement {
  constructor() {
    super(),
      (this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      }),
      this.elements.button.addEventListener('click', this.openSelector.bind(this)),
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this)),
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this)),
      this.querySelectorAll('a').forEach((e) => e.addEventListener('click', this.onItemClick.bind(this)));
  }
  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false'), this.elements.panel.setAttribute('hidden', !0);
  }
  onContainerKeyUp(e) {
    'ESCAPE' === e.code.toUpperCase() && (this.hidePanel(), this.elements.button.focus());
  }
  onItemClick(e) {
    e.preventDefault(),
      (this.elements.input.value = e.currentTarget.dataset.value),
      this.querySelector('form')?.submit();
  }
  openSelector() {
    this.elements.button.focus(),
      this.elements.panel.toggleAttribute('hidden'),
      this.elements.button.setAttribute(
        'aria-expanded',
        ('false' === this.elements.button.getAttribute('aria-expanded')).toString()
      );
  }
  closeSelector(e) {
    this.contains(e.relatedTarget) || this.hidePanel();
  }
}
customElements.define('localization-form', LocalizationForm);
class MobileLocalizationForm extends HTMLElement {
  constructor() {
    super(),
      (this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button.mobile-localization-form__button'),
        buttonBack: this.querySelector('button.mobile-localization-form__back'),
        submenu: this.querySelector('.mobile-localization-form__submenu'),
      }),
      this.elements.button.addEventListener('click', this.openSelector.bind(this)),
      this.elements.buttonBack.addEventListener('click', this.closeSelector.bind(this)),
      this.querySelectorAll('a').forEach((e) => e.addEventListener('click', this.onItemClick.bind(this)));
  }
  onItemClick(e) {
    e.preventDefault(),
      (this.elements.input.value = e.currentTarget.dataset.value),
      this.querySelector('form')?.submit();
  }
  openSelector() {
    this.elements.button.setAttribute('aria-expanded', 'true'), this.elements.submenu.classList.add('active');
  }
  closeSelector() {
    this.elements.button.setAttribute('aria-expanded', 'false'), this.elements.submenu.classList.remove('active');
  }
}
customElements.define('mobile-localization-form', MobileLocalizationForm);
class SwipeMobile {
  constructor(el, direction = 'down', threshold = 160, closeTime = 400, callback = () => {}) {
    this.element = el;
    this.control = this.element.querySelector('.js-mobile-swipe-control') || this.element;
    this.direction = {
      down: direction === 'down',
      up: direction === 'up',
      right: direction === 'right',
      left: direction === 'left',
    };
    this.orientation = {
      vertical: direction === 'down' || direction === 'up',
      horizontal: direction === 'right' || direction === 'left',
    };
    this.threshold = threshold;
    this.closeAnimationTime = closeTime;
    this.closeCallback = callback;
    this.start = { x: 0, y: 0 };
    this.delta = { x: 0, y: 0 };
    this.closeTransform = {
      x: `translateX(${this.direction.right ? '110%' : '-110%'})`,
      y: `translateY(${this.direction.down ? '110%' : '-110%'})`,
    };

    this.startTouch = this.startTouch.bind(this);
    this.moveTouch = this.moveTouch.bind(this);
    this.endTouch = this.endTouch.bind(this);

    this.init();
  }

  close() {
    this.control.removeEventListener('touchmove', this.moveTouch);
    this.control.removeEventListener('touchend', this.endTouch);
    this.element.style.transform = this.orientation.vertical ? this.closeTransform.y : this.closeTransform.x;
    this.element.style.transition = `transform ${this.closeAnimationTime}ms`;
    setTimeout(() => {
      this.element.style.transform = '';
      this.element.style.transition = '';
      this.closeCallback();
    }, this.closeAnimationTime);
  }

  startTouch(e) {
    e.stopPropagation();
    this.control.addEventListener('touchmove', this.moveTouch, { passive: true });
    this.control.addEventListener('touchend', this.endTouch, { passive: true });
    this.start.x = e.touches[0].clientX;
    this.start.y = e.touches[0].clientY;
    this.element.style.transition = 'transform 0ms linear 0ms';
  }

  moveTouch(e) {
    e.stopPropagation();
    this.delta.x = e.touches[0].clientX - this.start.x;
    this.delta.y = e.touches[0].clientY - this.start.y;

    if (
      (this.orientation.vertical && this.direction.down && this.delta.y <= 0) ||
      (this.direction.up && this.delta.y >= 0) ||
      (this.orientation.horizontal && this.direction.right && this.delta.x <= 0) ||
      (this.direction.left && this.delta.x >= 0)
    )
      return;

    const transform = this.orientation.vertical ? `translateY(${this.delta.y}px)` : `translateX(${this.delta.x}px)`;

    this.element.style.transform = transform;
  }

  endTouch(e) {
    e.stopPropagation();
    this.element.style.transition = '';
    this.element.style.transform = '';

    const shouldClose =
      (this.orientation.vertical &&
        ((this.direction.down && this.delta.y >= this.threshold) ||
          (this.direction.up && this.delta.y <= -this.threshold))) ||
      (this.orientation.horizontal &&
        ((this.direction.right && this.delta.x >= this.threshold) ||
          (this.direction.left && this.delta.x <= -this.threshold)));

    if (shouldClose) this.close();

    this.reset();
  }

  reset() {
    this.start = { x: 0, y: 0 };
    this.delta = { x: 0, y: 0 };
  }

  init() {
    new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.contentRect.width < 576) {
          this.control.addEventListener('touchstart', this.startTouch, { passive: true });
        } else {
          this.control.removeEventListener('touchstart', this.startTouch);
          this.control.removeEventListener('touchmove', this.moveTouch);
          this.control.removeEventListener('touchend', this.endTouch);
        }
      });
    }).observe(document.documentElement);
  }
}

document.querySelectorAll('.js-mobile-swipe').forEach((el) => {
  let direction;
  let callback = () => {};

  if (el.classList.contains('js-mobile-swipe-up')) direction = 'up';
  else if (el.classList.contains('js-mobile-swipe-down')) direction = 'down';
  else if (el.classList.contains('js-mobile-swipe-right')) direction = 'right';
  else if (el.classList.contains('js-mobile-swipe-left')) direction = 'left';
  else return;

  if (el.classList.contains('popup')) {
    callback = () => {
      el.classList.remove('popup-open');
      el.classList.add('popup-already-opened');
      document.body.classList.remove('popup-scroll-hidden', 'popup-scroll-hidden-mobile');
    };
  }

  if (el.classList.contains('banner-products__wrapper')) {
    callback = () => {
      el.closest('.banner-products__inner').classList.remove('active');
      document.body.classList.remove('overflow-hidden-products');
    };
  }

  if (el.classList.contains('quick-add-modal__content')) {
    callback = () => {
      el.closest('quick-add-modal').hide(true);
    };
  }

  if (el.classList.contains('drawer__inner') && el.closest('cart-drawer')) {
    callback = () => {
      el.closest('cart-drawer').close();
    };
  }

  if (el.id === 'menu-drawer' && el.closest('header-drawer')) {
    callback = () => {
      el.closest('header-drawer').closeMenuDrawer(true);
    };
  }

  if (el.classList.contains('menu-drawer__submenu') && (el.id.startsWith('childlink-') || el.id.startsWith('link-'))) {
    callback = () => {
      el.closest('menu-drawer').closeSubmenu(el.closest('menu-drawer').mainDetailsToggle);
    };
  }

  if (el.classList.contains('mobile-localization-form__submenu') && el.closest('mobile-localization-form')) {
    callback = () => {
      el.closest('mobile-localization-form').closeSelector();
    };
  }

  new SwipeMobile(el, direction, 160, 400, callback);
});

class DeviceColor extends HTMLElement {
  constructor() {
    super();
    this.currentColor = null;
    this.wrappers = document.querySelectorAll('.product__media-wrapper');
    this.variantOptions = document.querySelectorAll('variant-radios .variant-swatch');
    this.buttons = this.querySelectorAll('button');

    this.addEventListener('click', this.onButtonClick.bind(this));
  }

  updateVariantOptions(color) {
    if (!this.variantOptions) return;
    this.variantOptions.forEach((option) => {
      const currentColor = option.dataset.currentColor;
      if (currentColor === color) return;

      const newImageUrl = option.style.backgroundImage?.replace(currentColor, color);
      option.style.backgroundImage = newImageUrl;
      option.dataset.currentColor = color;
    });
  }

  onButtonClick(e) {
    e.preventDefault();

    const color = e?.target?.dataset?.name;
    if (color == undefined || this.currentColor === color) return;

    this.buttons.forEach((button) => button.classList.toggle('active', button == e.target));
    this.wrappers.forEach((wrapper) => {
      const swiper = wrapper.querySelector('.product__media-list')?.swiper;
      if (swiper) filterSlides(swiper, color, null);
    });
    this.updateVariantOptions(color);
  }
}

if (!customElements.get('device-color')) {
  customElements.define('device-color', DeviceColor);
}
